import { render, staticRenderFns } from "./FileTransferModal.vue?vue&type=template&id=019f8792&scoped=true&"
import script from "./FileTransferModal.vue?vue&type=script&lang=js&"
export * from "./FileTransferModal.vue?vue&type=script&lang=js&"
import style0 from "./FileTransferModal.vue?vue&type=style&index=0&id=019f8792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019f8792",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('019f8792')) {
      api.createRecord('019f8792', component.options)
    } else {
      api.reload('019f8792', component.options)
    }
    module.hot.accept("./FileTransferModal.vue?vue&type=template&id=019f8792&scoped=true&", function () {
      api.rerender('019f8792', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/support/FileTransferModal.vue"
export default component.exports